// extracted by mini-css-extract-plugin
export default {"main":"page-wrap_main__97r8p","contentWrap":"page-wrap_contentWrap__EPcJY","pageTitle":"page-wrap_pageTitle__HiSpU"};